import { AsyncActions } from '../../standard-actions';
import { NBN_TESTS_POLL } from './action-types';
import { INBNTestData } from '../state/nbn-test-results';

export interface ILoadNbnTestAction extends AsyncActions.IAsyncFetchableAction<NBN_TESTS_POLL> {
    data?: INBNTestData[];
};

export interface ILoadNbnTestSuccessAction extends AsyncActions.IAsyncAction<NBN_TESTS_POLL> {
    data: INBNTestData[];
};

export type ILoadNbnTestErrorAction = AsyncActions.IAsyncErrorAction<NBN_TESTS_POLL>;

export const loadTestStart = (): ILoadNbnTestAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: NBN_TESTS_POLL,
    isFetchable: true
});

export const loadTestSuccess = (data: INBNTestData[]): ILoadNbnTestSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: NBN_TESTS_POLL,
    data
});

export const loadTestError = (error: string): ILoadNbnTestErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: NBN_TESTS_POLL,
    error
});
